import React, { useState } from 'react';
import { Tabs } from 'antd';
import { FaLink } from "react-icons/fa6";
import { RiSearchEyeFill } from "react-icons/ri";
import { modernTitle } from '../../secondUtils/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
const includeIndices1 = [3, 5];
const includeIndices2 = [1, 4, 9];
const includeIndices3 = [6, 10];
const includeIndices4 = [2, 7, 11];
const includeIndices5 = [0, 8];

const PortfolioTabs = (props) => {
    const [activeKey, setActiveKey] = useState("1");
    const history = useHistory()
    const { selectedLanguage, language, showModal } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const onChange = (key) => {
        setActiveKey(key);
    };
    const tabData = [
        {
            id: 1,
            label: selectedLanguage?.txt_all,
            content: <div className='procedure-cards-div portfolio-card-img'>
                {
                    modernTitle?.map((v, i) => {
                        return (
                            <div key={i}>
                                <img src={v?.imageUrl} alt="" />
                                <div className='portfolio-card-img-overlay'>
                                    <div>
                                        <div className='portfolio-card-img-overlay-btn-div'>
                                            <button onClick={() => history?.push(v?.path)}><RiSearchEyeFill /></button>
                                            <button onClick={() => showModal(v?.imageUrl)}><FaLink /></button>
                                        </div>
                                        <div className='portfolio-card-img-overlay-text'>
                                            <p>{isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                                <br />
                                                {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        },
        {
            id: 2,
            label: selectedLanguage?.txt_braces,
            content: <div className='procedure-cards-div portfolio-card-img'>
                {modernTitle.filter((v, i) => includeIndices1.includes(i))
                    .map((v, i) => (
                        <div key={i}>
                            <img src={v.imageUrl} alt="" />
                            <div className='portfolio-card-img-overlay'>
                                <div>
                                    <div className='portfolio-card-img-overlay-btn-div'>
                                        <button onClick={() => history?.push(v?.path)}><RiSearchEyeFill /></button>
                                        <button onClick={() => showModal(v?.imageUrl)}><FaLink /></button>
                                    </div>
                                    <div className='portfolio-card-img-overlay-text'>
                                        <p>{isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                            <br />
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        },
        {
            id: 3,
            label: selectedLanguage?.txt_cosmetic,
            content: <div className='procedure-cards-div portfolio-card-img'>
                {modernTitle.filter((v, i) => includeIndices2.includes(i))
                    .map((v, i) => (
                        <div key={i}>
                            <img src={v.imageUrl} alt="" />
                            <div className='portfolio-card-img-overlay'>
                                <div>
                                    <div className='portfolio-card-img-overlay-btn-div'>
                                        <button onClick={() => history?.push(v?.path)}><RiSearchEyeFill /></button>
                                        <button onClick={() => showModal(v?.imageUrl)}><FaLink /></button>
                                    </div>
                                    <div className='portfolio-card-img-overlay-text'>
                                        <p>{isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                            <br />
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        },
        {
            id: 4,
            label: selectedLanguage?.txt_implants,
            content: <div className='procedure-cards-div portfolio-card-img'>
                {modernTitle.filter((v, i) => includeIndices3.includes(i))
                    .map((v, i) => (
                        <div key={i}>
                            <img src={v.imageUrl} alt="" />
                            <div className='portfolio-card-img-overlay'>
                                <div>
                                    <div className='portfolio-card-img-overlay-btn-div'>
                                        <button onClick={() => history?.push(v?.path)}><RiSearchEyeFill /></button>
                                        <button onClick={() => showModal(v?.imageUrl)}><FaLink /></button>
                                    </div>
                                    <div className='portfolio-card-img-overlay-text'>
                                        <p>{isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                            <br />
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        },
        {
            id: 5,
            label: selectedLanguage?.txt_invisalign,
            content: <div className='procedure-cards-div portfolio-card-img'>
                {modernTitle.filter((v, i) => includeIndices4.includes(i))
                    .map((v, i) => (
                        <div key={i}>
                            <img src={v.imageUrl} alt="" />
                            <div className='portfolio-card-img-overlay'>
                                <div>
                                    <div className='portfolio-card-img-overlay-btn-div'>
                                        <button onClick={() => history?.push(v?.path)}><RiSearchEyeFill /></button>
                                        <button onClick={() => showModal(v?.imageUrl)}><FaLink /></button>
                                    </div>
                                    <div className='portfolio-card-img-overlay-text'>
                                        <p>{isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                            <br />
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        },
        {
            id: 6,
            label: selectedLanguage?.txt_veneers,
            content: <div className='procedure-cards-div portfolio-card-img'>
                {modernTitle.filter((v, i) => includeIndices5.includes(i))
                    .map((v, i) => (
                        <div key={i}>
                            <img src={v.imageUrl} alt="" />
                            <div className='portfolio-card-img-overlay'>
                                <div>
                                    <div className='portfolio-card-img-overlay-btn-div'>
                                        <button onClick={() => history?.push(v?.path)}><RiSearchEyeFill /></button>
                                        <button onClick={() => showModal(v?.imageUrl)}><FaLink /></button>
                                    </div>
                                    <div className='portfolio-card-img-overlay-text'>
                                        <p>{isELSelect ? v?.heading : (isAlSelect ? v?.alHeading : v?.glHeading)}
                                            <br />
                                            {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        },
    ];
    return (
        <div className='portfolioTabs-main'>
            <Tabs
                activeKey={activeKey}
                defaultActiveKey="1"
                centered
                items={tabData.map(tab => ({
                    label: (
                        <span
                            className={tab.id.toString() === activeKey ? "portfolio-active-tab portfolio-tab-label" : "portfolio-tab-label"}
                            onClick={() => onChange(tab.id.toString())}
                        >
                            {tab.label}
                        </span>
                    ),
                    key: tab.id.toString(),
                    children: tab.content,
                }))}
            />
        </div>
    )
};

export default PortfolioTabs;
